import * as React from "react";
import injectSheet from "react-jss";
import { themeListener } from "theming";

const styleSheet = (theme: any) => ({
  center: theme.center
});

interface CenterProps {
  theme?: any;
  classes?: any;
  position?: string;
}
const Center: React.FC<CenterProps> = props => {
  return (
    <div
      style={{ position: props.position === "top" ? "relative" : "fixed" }}
      className={props.classes.center}
    >
      {props.children}
    </div>
  );
};

export default injectSheet(styleSheet)(Center);
